module.exports = __webpack_public_path__ + "static/media/discussion-amico-people.2ccc3449.svg";